import React from 'react';
import { ArrowDown } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-20 px-4 overflow-hidden" data-id="element-34">
      <div className="max-w-4xl mx-auto text-center" data-id="element-35">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#2D3436] mb-4 leading-tight" data-id="element-36">
          YOGA ESENCIAL
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="text-2xl md:text-3xl font-serif text-[#9CAF88] mb-6" data-id="element-37">
          Ordená tu cuerpo y tu mente
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-xl md:text-2xl text-gray-600 mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-38">
          No es motivación.{' '}
          <span className="font-semibold text-[#2D3436]" data-id="element-39">Es estructura.</span>
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-lg md:text-xl text-gray-500 mb-10 max-w-2xl mx-auto" data-id="element-40">
          Un camino claro para practicar, avanzar y sentirte bien con vos.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative mx-auto mb-12 max-w-md cursor-pointer group" onClick={scrollToCheckout} data-id="element-41">
          <div className="absolute inset-0 bg-[#9CAF88]/20 rounded-2xl transform rotate-3 transition-transform group-hover:rotate-6 duration-500" data-id="element-42"></div>
          <div className="absolute inset-0 bg-[#E8D5D5]/30 rounded-2xl transform -rotate-3 transition-transform group-hover:-rotate-6 duration-500" data-id="element-43"></div>
          <img src="https://cdn.magicpatterns.com/uploads/97DFhkMoqVSfzwTqVRHxx5/ChatGPT_Image_28_ene_2026,_18_45_57.png" alt="Yoga Esencial - De Cero a Práctica Consciente" className="relative rounded-2xl shadow-2xl w-full h-auto object-contain" data-id="element-44" />
        </motion.div>

        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={scrollToCheckout} className="bg-[#9CAF88] hover:bg-[#7A8C69] text-white text-lg md:text-xl font-bold py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 mx-auto" data-id="element-45">
          Quiero Empezar Mi Cambio Hoy
          <ArrowDown size={20} data-id="element-46" />
        </motion.button>
      </div>
    </section>;
}